import { Link } from "react-router-dom";
import { Mail, Phone, Globe } from "lucide-react";
import { Logo } from "@/components/Logo";
import { LeadMagnet } from "@/components/LeadMagnet";
import { CONTACT, COMPANY } from "@/data/content";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-navy text-white grain-overlay relative overflow-hidden" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16 relative z-10">
        <div className="mb-14 pb-14 border-b border-white/10 grid gap-8 lg:grid-cols-[1.3fr_1fr] lg:items-center">
          <div>
            <Logo variant="white" full lockupClassName="h-11 w-auto" />
            <p className="mt-5 text-white/70 text-sm leading-relaxed max-w-md">
              Independent technology and cyber security advisory for growing UK organisations. Advice-first, vendor-agnostic — never an MSP.
            </p>
          </div>
          <div className="lg:max-w-sm lg:justify-self-end w-full">
            <LeadMagnet variant="compact" />
          </div>
        </div>

        <div className="grid gap-12 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <Logo variant="white" full lockupClassName="h-12 w-auto" />
            <p className="mt-6 text-xs font-semibold tracking-[0.2em] text-cyan">{COMPANY.brandTagline}</p>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-white/50 uppercase">Explore</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/services" className="text-white/80 hover:text-cyan transition-colors" data-testid="footer-services">Services</Link></li>
              <li><Link to="/packages" className="text-white/80 hover:text-cyan transition-colors">Packages &amp; Pricing</Link></li>
              <li><Link to="/how-we-work" className="text-white/80 hover:text-cyan transition-colors">How We Work</Link></li>
              <li><Link to="/about" className="text-white/80 hover:text-cyan transition-colors">Why TWORAY</Link></li>
              <li><Link to="/contact" className="text-white/80 hover:text-cyan transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-white/50 uppercase">Legal</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/legal/privacy" className="text-white/80 hover:text-cyan transition-colors" data-testid="footer-privacy">Privacy</Link></li>
              <li><Link to="/legal/cookies" className="text-white/80 hover:text-cyan transition-colors">Cookies</Link></li>
              <li><Link to="/legal/terms" className="text-white/80 hover:text-cyan transition-colors" data-testid="footer-terms">Website Terms</Link></li>
              <li><Link to="/legal/nda" className="text-white/80 hover:text-cyan transition-colors">Mutual NDA</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold tracking-[0.2em] text-white/50 uppercase">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><a href={`mailto:${CONTACT.email}`} className="flex items-center gap-2 text-white/80 hover:text-cyan transition-colors" data-testid="footer-email"><Mail size={15} /> {CONTACT.email}</a></li>
              <li><a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-white/80 hover:text-cyan transition-colors"><Phone size={15} /> {CONTACT.phone}</a></li>
              <li><span className="flex items-center gap-2 text-white/80"><Globe size={15} /> {CONTACT.website}</span></li>
            </ul>
            <Link to="/book" className="mt-6 inline-flex bg-cyan text-navy font-semibold text-sm px-5 py-2.5 rounded-sm hover:bg-white transition-colors" data-testid="footer-book-cta">Book a Discovery Call</Link>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 text-xs text-white/45">
          <p>© {year} {COMPANY.name}. Registered in {COMPANY.jurisdiction}{COMPANY.regNumber ? ` · Company No. ${COMPANY.regNumber}` : ""}.</p>
        </div>
      </div>
    </footer>
  );
}
